export default {
  ADMINS_GUIDE_LINK: 'https://coligo.freshdesk.com/support/solutions/67000218135',
  STAFF_GUIDE_LINK: 'https://coligo.freshdesk.com/support/solutions/67000218134',
  PARENTS_GUIDE_LINK: 'https://coligo.freshdesk.com/support/solutions/67000218131',
  STUDENTS_GUIDE_LINK: 'https://coligo.freshdesk.com/support/solutions/67000218130',
  REPORT_ISSUE_LINK: 'https://coligo.freshdesk.com/support/tickets/new'
};